<template>
    <div v-if="visible">
        <div class="modal-backdrop fade show"></div>
        <div
            class="modal bo-modal bo-related-bundle-modal"
            tabindex="-1"
            role="dialog"
            style="display: block; z-index: 1050"
            @click.self="$emit('close')"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl"
                role="document"
            >
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title">{{ title }}</div>
                        <i
                            class="icon-close cursor-pointer bo-related-bundle-modal__close"
                            @click="$emit('close')"
                        ></i>
                    </div>
                    <div class="modal-body">
                        <!-- Renders what the PDP has loaded; it never fetches on its own. -->
                        <div :class="isMobile ? 'bo-related-bundle-modal__list' : 'bo-related-bundle-modal__grid'">
                            <template v-if="!complete && bundles.length === 0">
                                <bo-related-bundle-card-skeleton
                                    v-for="index in 4"
                                    :key="`skeleton-${index}`"
                                    :variant="isMobile ? 'list' : 'grid'"
                                ></bo-related-bundle-card-skeleton>
                            </template>
                            <bo-related-bundle-card
                                v-for="bundle in bundles"
                                :key="bundle.id"
                                :product="bundle"
                                :variant="isMobile ? 'list' : 'grid'"
                                :options="cardOptions"
                                @favorite="$emit('favorite', $event)"
                            ></bo-related-bundle-card>
                        </div>
                        <div
                            v-if="!complete && bundles.length > 0"
                            class="bo-related-bundle-modal__loading"
                        >
                            <span
                                class="spinner-border spinner-border-sm"
                                role="status"
                            ></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BoRelatedBundleCard from "js/frontend/components/bo-related-bundle-card.vue";
import BoRelatedBundleCardSkeleton from "js/frontend/components/bo-related-bundle-card-skeleton.vue";

// "Also Available As" modal: every related bundle, as a grid on desktop and a list on mobile.
export default {
    components: { BoRelatedBundleCard, BoRelatedBundleCardSkeleton },

    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        bundles: {
            type: Array,
            default: () => [],
        },
        // false while later pages are still loading
        complete: {
            type: Boolean,
            default: true,
        },
        isMobile: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: "Also Available As",
        },
        cardOptions: {
            type: Object,
            required: true,
        },
    },
};
</script>
